import { color } from '@/shared/styles/assets/colors';
import Typography, { type TypographyProps } from '@mui/material/Typography';

type TextProps = TypographyProps;

const mergeSx = (base: NonNullable<TypographyProps['sx']>, sx: TypographyProps['sx']): TypographyProps['sx'] => [
  base,
  ...(Array.isArray(sx) ? sx : [sx])
];

export const H1 = ({ sx, ...props }: TextProps) => (
  <Typography color={'textPrimary'} variant="h1" component="div" {...props} sx={mergeSx({ fontWeight: 600 }, sx)} />
);

export const H2 = ({ sx, ...props }: TextProps) => (
  <Typography color={'textPrimary'} variant="h2" component="div" {...props} sx={mergeSx({ fontWeight: 600 }, sx)} />
);

export const H3 = ({ sx, ...props }: TextProps) => (
  <Typography color={'textPrimary'} variant="h3" component="div" {...props} sx={mergeSx({ fontWeight: 600 }, sx)} />
);

export const H4 = ({ sx, ...props }: TextProps) => (
  <Typography color={'textPrimary'} variant="h4" component="div" {...props} sx={mergeSx({ fontWeight: 600 }, sx)} />
);

export const H5 = ({ sx, ...props }: TextProps) => (
  <Typography color={'textPrimary'} variant="h5" component="div" {...props} sx={mergeSx({ fontWeight: 600 }, sx)} />
);

export const H6 = ({ sx, ...props }: TextProps) => (
  <Typography color={'textPrimary'} variant="h6" component="div" {...props} sx={mergeSx({ fontWeight: 600 }, sx)} />
);

export const Body1 = ({ ...props }: TextProps) => {
  return <Typography color={'textPrimary'} variant="body1" component="div" {...props} />;
};

export const Body2 = ({ ...props }: TextProps) => {
  return <Typography color={'textPrimary'} variant="body2" component="div" {...props} />;
};

export const Small = ({ ...props }: TextProps) => {
  return <Typography color={'textPrimary'} variant="caption" component="div" {...props} />;
};

export const Caption = ({ sx, ...props }: TextProps) => (
  <Typography color={'textPrimary'} variant="caption" component="div" {...props} sx={mergeSx({ textTransform: 'uppercase' }, sx)} />
);

export const Caption2 = ({ sx, ...props }: TextProps) => (
  <Typography
    color={'textPrimary'}
    variant="caption"
    component="div"
    {...props}
    sx={mergeSx({ textTransform: 'captilize', fontWeight: 80, fontSize: '0.83rem' }, sx)}
  />
);

export const Label = ({ sx, ...props }: TextProps) => (
  <Typography color={color.grey650} variant="body2" component="label" {...props} sx={mergeSx({ fontWeight: 'bold' }, sx)} />
);

export const LogText = ({ sx, ...props }: TextProps) => (
  <Typography color={color.grey750} variant="h6" component="div" {...props} sx={mergeSx({ fontWeight: 600 }, sx)} />
);

export const Subtitle = ({ sx, ...props }: TextProps) => (
  <Typography variant="subtitle1" component="div" {...props} sx={mergeSx({ fontSize: 'medium' }, sx)} />
);
